import { render, staticRenderFns } from "./ModalSuporteMotivoCancelamento.vue?vue&type=template&id=021a28de&scoped=true"
import script from "./ModalSuporteMotivoCancelamento.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteMotivoCancelamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteMotivoCancelamento.vue?vue&type=style&index=0&id=021a28de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a28de",
  null
  
)

export default component.exports